module.exports = __webpack_public_path__ + "static/media/20.21412841.png";